var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRestore(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons / Filled / Reply"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.24843 3.95157C9.71706 4.4202 9.71706 5.18 9.24843 5.64863L6.49696 8.4001H13.1999C17.8391 8.4001 21.5999 12.1609 21.5999 16.8001V19.2001C21.5999 19.8628 21.0626 20.4001 20.3999 20.4001C19.7372 20.4001 19.1999 19.8628 19.1999 19.2001V16.8001C19.1999 13.4864 16.5136 10.8001 13.1999 10.8001H6.49696L9.24843 13.5516C9.71706 14.0202 9.71706 14.78 9.24843 15.2486C8.7798 15.7173 8.02 15.7173 7.55137 15.2486L2.75137 10.4486C2.28275 9.98 2.28275 9.2202 2.75137 8.75157L7.55137 3.95157C8.02 3.48294 8.7798 3.48294 9.24843 3.95157Z",
    fill: "#4A5568"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestore);
export default __webpack_public_path__ + "static/media/restore.2f8ba6ad766ba49e5084a28f0824d630.svg";
export { ForwardRef as ReactComponent };